import { Advertisement } from "@/client";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";

interface DeleteAdvertisementDialogProps {
  advertisement: Advertisement | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

function DeleteAdvertisementDialog({
  advertisement,
  open,
  onOpenChange,
  onConfirm,
}: DeleteAdvertisementDialogProps) {
  const { t } = useTranslation();
  if (!advertisement) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t("confirmDialog.title")}</DialogTitle>
          <DialogDescription className="space-y-2">
            <p>
              {t("confirmDialog.description")} &ldquo;{advertisement.name}&rdquo;.
            </p>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end space-x-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            {t("confirmDialog.cancel")}
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm}>
            {t("deleteCongress.delete")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export { DeleteAdvertisementDialog };
